module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#text",
      toString: function () {
        return this.url;
      }
    }